export const groupBy = <T extends Record<string, any>>(
  items: T[],
  key: keyof T,
): Record<string, T[]> =>
  items?.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [...(result[item[key]] || []), item],
    }),
    {} as Record<string, T[]>,
  ) || {};
